/**
 * Environment configuration
 * Access environment variables through this centralized config
 */

const config = {
  apiUrl: process.env.REACT_APP_API_URL || "http://localhost:3001/api",
  environment: process.env.REACT_APP_ENV || process.env.NODE_ENV || "development",
  appName: process.env.REACT_APP_APP_NAME || "Puriff Hygiene",
  isDevelopment: process.env.NODE_ENV === "development",
  isProduction: process.env.NODE_ENV === "production",
};

// Validate required config in production
if (config.isProduction) {
  if (!process.env.REACT_APP_API_URL) {
    console.warn("Warning: REACT_APP_API_URL is not set in production");
  }
}

export default config;
